import { render, staticRenderFns } from "./currentt.vue?vue&type=template&id=9bd9d92a&scoped=true&"
import script from "./currentt.vue?vue&type=script&lang=js&"
export * from "./currentt.vue?vue&type=script&lang=js&"
import style0 from "./currentt.vue?vue&type=style&index=0&id=9bd9d92a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd9d92a",
  null
  
)

export default component.exports